// BreadcrumbNav.jsx
// Component for breadcrumb navigation on listing details page

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, LAYOUT } from '../../constants';

// Modern SVG Icons
const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9,18 15,12 9,6"></polyline>
  </svg>
);

const HomeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9,22 9,12 15,12 15,22"></polyline>
  </svg>
);

const BreadcrumbNav = ({ listing }) => {
  const navigate = useNavigate();

  if (!listing) return null;

  const breadcrumbs = [
    { label: 'Home', path: '/', icon: <HomeIcon /> },
    { label: 'Market', path: '/market' },
    { label: listing.category, path: `/market?category=${encodeURIComponent(listing.category)}` },
    { label: listing.title, path: null, current: true }
  ];

  return (
    <div style={modernStyles.container}>
      <nav style={modernStyles.nav}>
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={index}>
            {index > 0 && (
              <div style={modernStyles.separator}>
                <ChevronRightIcon />
              </div>
            )}
            
            {crumb.current ? (
              <span style={modernStyles.currentCrumb}>
                {crumb.label.length > 30 ? `${crumb.label.slice(0, 30)}...` : crumb.label}
              </span>
            ) : (
              <button
                onClick={() => navigate(crumb.path)}
                style={modernStyles.crumbButton}
              >
                {crumb.icon && (
                  <span style={modernStyles.crumbIcon}>{crumb.icon}</span>
                )}
                <span>{crumb.label}</span>
              </button>
            )}
          </React.Fragment>
        ))}
      </nav>
    </div>
  );
};

// Modern styles
const modernStyles = {
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: `${LAYOUT.spacing.md} ${LAYOUT.spacing.lg}`,
    backgroundColor: COLORS.white,
    borderBottom: `1px solid ${COLORS.border}`,
    position: 'sticky',
    top: 0,
    zIndex: 5,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.sm,
    flexWrap: 'wrap',
  },
  separator: {
    color: COLORS.text.muted,
    display: 'flex',
    alignItems: 'center',
  },
  crumbButton: {
    background: 'none',
    border: 'none',
    color: COLORS.primary,
    fontSize: '0.875rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.xs,
    padding: `${LAYOUT.spacing.xs} ${LAYOUT.spacing.sm}`,
    borderRadius: LAYOUT.borderRadius.sm,
    transition: 'all 0.2s ease',
    fontWeight: '500',
    textDecoration: 'none',
  },
  crumbIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  currentCrumb: {
    fontSize: '0.875rem',
    color: COLORS.text.secondary,
    fontWeight: '500',
    padding: `${LAYOUT.spacing.xs} ${LAYOUT.spacing.sm}`,
  },
};

export default BreadcrumbNav;